import { useState } from 'react';
import { ResponsiveContainer, Legend, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Label } from 'recharts';
import useTranslation from '../../Language/useTranslation';




// "Laub_lost_2016_2020": 5159,
// "Laub_lost_2020_2021": 1000,
// "Laub_lost_2021_2020": 2000,
// "Nadel_lost_2016_2020": 21292,
// "Nadel_lost_2020_2021": 2000,
// "Nadel_lost_2021_2020": 3000,

// const getIntroOfPage = (label: any) => {
//     if (label === "Page A") {
//         return "Page A is about men's clothing";
//     }
//     if (label === "Page B") {
//         return "Page B is about women's dress";
//     }
//     if (label === "Page C") {
//         return "Page C is about women's bag";
//     }
//     if (label === "Page D") {
//         return "Page D is about household goods";
//     }
//     if (label === "Page E") {
//         return "Page E is about food";
//     }
//     if (label === "Page F") {
//         return "Page F is about baby food";
//     }
//     return "";
// };


const COLORS = ['#a055c3', '#e186ef', '#c4b1e8', '#b4e2d5'];
const PERIODS = ["loss_2016_2020", "loss_2020_2021", "loss_2021_2022", "loss_2022_2023"];
const LABELS = ["2017 - 2020", "2020 - 2021", "2021 - 2022", "2022 - 2023"];

export default function BarChartForestStatus(props: any) {
    const t = useTranslation();
    const mobile = window.innerWidth < 600;

    const data = [
        {
            //If mobile, split name by space an only show first part
            name: !mobile ? t.namesUIElements.schadflaechenBarLaubwald.name : t.namesUIElements.schadflaechenBarLaubwald.name.split(" ")[0],
            loss_2016_2020: props.statisticsBundesland["Laub_lost_2016_2020"],
            loss_2020_2021: props.statisticsBundesland["Laub_lost_2020_2021"],
            loss_2021_2022: props.statisticsBundesland["Laub_lost_2021_2022"],
            loss_2022_2023: props.statisticsBundesland["Laub_lost_2022_2023"],
            sum: props.statisticsBundesland["Laub_lost_2022_2023"] + props.statisticsBundesland["Laub_lost_2016_2020"],

        },
        {
            //If mobile, split name by space an only show first part
            name: !mobile ? t.namesUIElements.schadflaechenBarNadelwald.name : t.namesUIElements.schadflaechenBarNadelwald.name.split(" ")[0],
            loss_2016_2020: props.statisticsBundesland["Nadel_lost_2016_2020"],
            loss_2020_2021: props.statisticsBundesland["Nadel_lost_2020_2021"],
            loss_2021_2022: props.statisticsBundesland["Nadel_lost_2021_2022"],
            loss_2022_2023: props.statisticsBundesland["Nadel_lost_2022_2023"],
            sum: props.statisticsBundesland["Nadel_lost_2022_2023"] + props.statisticsBundesland["Nadel_lost_2016_2020"],
        },
    ];

    // const CustomTooltip = ({ active, payload, label }: any) => {
    //     if (active && payload && payload.length) {
    //         console.log(payload)
    //         return (
    //             <div className="custom-tooltip">
    //                 {/* <p className="label">{`${label} : ${payload[0].value}`}</p>
    //           <p className="label">{`${label} : ${payload[0].value}`}</p>

    //           <p className="intro">{getIntroOfPage(label)}</p>
    //           <p className="desc">Anything you want can be displayed here.</p> */}
    //                 <p className="label">{`Laubwald `}</p>
    //             </div>
    //         );
    //     }

    //     return null;
    // };


    // Create a stacked bar chart with Recharts
    // when hovering over one part of the bar, this one is highlighted and the other parts are greyed out. Furthermore, the tooltip shows the exact values of the hovered part.
    // Show two bars for each type of forest (Laubwald, Nadelwald) and stack the periods (2016-2020, 2020-2021) on top of each other
    // hover over 2016-2020: show 2016-2020 and grey out 2020-2021

    // const COLORS = ['#FF4C30', '#b33322'];
    const [colors, setColors] = useState({
        [PERIODS[0]]: COLORS[0],
        [PERIODS[1]]: COLORS[1],
        [PERIODS[2]]: COLORS[2],
        [PERIODS[3]]: COLORS[3],
    });

    function handleOnMouseEnter(hoveredPeriod: string) {
        // setColors({ ...colors, [hoveredPeriod]: COLORS[0] });
    }

    function handleOnMouseLeave(hoveredPeriod: string) {
        //Reset colors
        setColors({
            [PERIODS[0]]: COLORS[0],
            [PERIODS[1]]: COLORS[1],
            [PERIODS[2]]: COLORS[2],
            [PERIODS[3]]: COLORS[3],
        });
    }


    return (
        <div style={{ width: '100%', height: 300 }}>

            <ResponsiveContainer>
                <BarChart
                    data={data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    {/* <CartesianGrid strokeDasharray="3 3" /> */}
                    <XAxis dataKey="name">
                        {/* <Label value="Waldtyp" offset={0} position="insideBottom" /> */}
                    </XAxis>
                    <YAxis
                        tickFormatter={(tick: any) => tick.toLocaleString('de-DE')}
                        label={{ value: 'ha', angle: -90, position: 'insideLeft', offset: -10, fill: "#626262" }} />
                    <Tooltip
                        contentStyle={{ backgroundColor: '#1D1D1D', border: 0 }}
                        cursor={{ fill: '#1D1D1D' }}
                        //  cursor={false}
                        // content={<CustomTooltip />}
                        formatter={(value: number, name: string, payload: any) => {
                            let label
                            PERIODS.forEach((period) => {
                                if (name === period) {
                                    label = `${LABELS[PERIODS.indexOf(period)]}`
                                }
                            })
                            return [value.toLocaleString('de-DE') + " ha", label]
                        }
                        }

                    />
                    <Legend content={renderLegend}
                    // formatter={
                    //     (value: string, entry: any, index: number) => {
                    //         return LABELS[index]
                    //     }
                    // }
                    />

                    {PERIODS.map((period) => (
                        <Bar
                            shape={BarWithBorder(1, "#9E9E9E")}
                            dataKey={period}
                            stackId="a"
                            fill={colors[period]}
                            name={period}
                            onMouseEnter={() => handleOnMouseEnter(period)}
                            onMouseLeave={() => handleOnMouseLeave(period)} />
                    ))
                    }
                </BarChart>

            </ResponsiveContainer>
        </div>

    );


}

const renderLegend = (props: any) => {
    // Render a recharts legend that shows only one value "Schadflächen" in the style of the usual recharts legend

    const { payload } = props;
    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                <div style={{ width: 10, height: 10, backgroundColor: COLORS[0], marginRight: 5, marginLeft: 5 }}></div>
                {/* <div style={{ fontSize: 16, color: "#626262" }}>2017-2020</div> */}
                <div style={{ fontSize: 16, color: "#D1D1D1" }}>2017-2020</div>
                <div style={{ width: 10, height: 10, backgroundColor: COLORS[1], marginRight: 5, marginLeft: 10 }}></div>
                {/* <div style={{ fontSize: 16, color: "#626262" }}>2020-2021</div> */}
                <div style={{ fontSize: 16, color: "#D1D1D1" }}>2020-2021</div>
                <div style={{ width: 10, height: 10, backgroundColor: COLORS[2], marginRight: 5, marginLeft: 10 }}></div>
                {/* <div style={{ fontSize: 16, color: "#626262" }}>2021-2020</div> */}
                <div style={{ fontSize: 16, color: "#D1D1D1" }}>2021-2020</div>
                <div style={{ width: 10, height: 10, backgroundColor: COLORS[3], marginRight: 5, marginLeft: 10 }}></div>
                {/* <div style={{ fontSize: 16, color: "#626262" }}>2022-2023</div> */}
                <div style={{ fontSize: 16, color: "#D1D1D1" }}>2022-2023</div>
            </div>
        </div>
    );

}

const BarWithBorder = (borderHeight: any, borderColor: any) => {
    return (props: any) => {
        const { fill, x, y, width, height } = props;
        //Make the following rectangle stroke with a dashed line
        return (
            <g>
                <rect x={x} y={y}
                    width={width}
                    height={height}
                    fill={fill}
                // stroke={borderColor}
                // strokeWidth={borderHeight}
                // strokeDasharray="3 3"
                />
                <rect x={x} y={y} width={width} height={borderHeight} stroke="none" fill={borderColor}
                // strokeDasharray="5 5"
                />
                {/* <line x={x} y={y}
                    width={width}
                    height={borderHeight}
                    stroke={borderColor}
                    strokeWidth={borderHeight}
                /> */}
            </g>
        );
    };
};
